import { IBrief } from "@shared/lib/types/brief";
import { Button } from "@shared/ui";
import { ColumnsType } from "antd/es/table";
import { ChevronRight } from "lucide-react";
import { NavigateFunction } from "react-router-dom";
import styles from "../styles.module.scss";
import { formatTimelineRange, getInitials } from "./utils/formatters";
import { getClosureDetailPath } from "./utils/routes";

export function getClosureBriefColumns(
  userIdParam: string,
  navigate: NavigateFunction
): ColumnsType<IBrief> {
  return [
    {
      title: "Project",
      key: "project",
      render: (_, record) => (
        <span className={styles.projectName}>{record.name}</span>
      ),
    },
    {
      title: "Brand",
      key: "brand",
      render: (_, record) => (
        <div className={styles.brandCell}>
          <span className={styles.brandAvatar}>
            {record?.brand?.name?.slice(0, 2).toUpperCase() || "—"}
          </span>
          <span className={styles.brandName}>{record?.brand?.name}</span>
        </div>
      ),
    },
    {
      title: "Account manager",
      key: "accountManager",
      render: (_, record) => {
        const manager = record.accountManagers?.[0];

        if (!manager) {
          return "—";
        }

        return (
          <span className={styles.accountManagerTag}>
            <span className={styles.accountManagerInitials}>
              {getInitials(manager.firstName, manager.lastName)}
            </span>
            {manager.firstName} {manager.lastName}
          </span>
        );
      },
    },
    {
      title: "Assigned timeline",
      key: "assignedTimeline",
      width: 250,
      render: (_, record) => (
        <span className={styles.timelineText}>
          {formatTimelineRange(
            record?.myPricingTracker?.[0]?.deadlineFrom,
            record?.myPricingTracker?.[0]?.deadlineTo
          )}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "right",
      render: (_, record) => (
        <Button
          type="link"
          className={styles.openProjectLink}
          icon={<ChevronRight size={16} />}
          iconPosition="end"
          onClick={() =>
            navigate(getClosureDetailPath(record._id, userIdParam))
          }
        >
          Open project
        </Button>
      ),
    },
  ];
}
